import { h, render, Fragment } from 'preact';
import CollectionGrid from './product-grid';
import { getCollectionProducts } from '../utils/storefront/get-products';


export default (element, data) => {

  const init = async () => {
    const encodedCollectionId = window.btoa(
      `gid://shopify/Collection/${data.collectionId}`,
    );

    const collectionProducts = await getCollectionProducts(encodedCollectionId);

    const content = (
      <>
        {!!collectionProducts.data?.node?.products?.edges?.length && (
          <CollectionGrid
            collectionProducts={collectionProducts.data?.node?.products?.edges}
          />
        )}
      </>
    );

    render(content, element);
  };

  

  init();
};
